import React from "react";
import Markdown from "react-markdown";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { ContainerWrapper, HelmetTitle } from "../../../Components/Utils";
import GlobalGERSMD from "../Contents/GlobalGERS.md";


export default class EcosystemSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      componentsDrop: 'Loading..',
    };
  }
  componentDidMount() {
    return this.update(GlobalGERSMD);
  }
 
  update(path) {
    return fetch(path, {
      mathod: 'get',
      header: {},
    }).then(response => {
      return response.text()
    }).then(text => {
      this.setState({
        componentsDrop: text
      })
    })
  }
  render() {
    const tablistClass = ['list-unstyled', 'ecosystem-tab__list'];
    const tabListItem = ['ecosystem-tab__list-item']
    const tabcontentClass = ['ecosystem-tab__panel'];
    return (
    <div>
      <HelmetTitle title="Ecosystem charter" />
      <ContainerWrapper textAlign="justify" className="my-2">
        <h3 className="banner-item__header">Ecosystem charter</h3>
        <p>Global GERS is an ecosystem that links member organizations worldwide to grow ventures early, rapidly and securely. The ecosystem enables interactions between the producers and the consumers of knowledge, products, services and technologies that support venture growth.</p>
        <p>Ecosystem members (members) include ventures, universities, regional innovation centres, professional associations, investment firms, service providers, international trade centers, government agencies, open source projects, municipalities and their own local networks.</p>
        <p>Each member,</p>
        <ul>
          <li>Owns resources and specialized capabilities that are required to support ventures’ growth</li>
          <li>Contributes to achieving the ecosystem’s objectives</li>
          <li>Affects and is affected by the others</li>
          <li>Collaborates and competes with others</li>
          <li>Survives by being flexible and adaptable</li>
        </ul>
        <Tabs>
          <div className="d-grid ecosystem-tab__grid">
            <div className="ecosystem__grid--1">
            <TabList className={tablistClass}>
              <Tab className={tabListItem}>Mission</Tab>
              <Tab className={tabListItem}>Goals</Tab>
              <Tab className={tabListItem}>Objectives</Tab>
              <Tab className={tabListItem}>Benefits</Tab>
              <Tab className={tabListItem}>Components</Tab>
            </TabList>
            </div>
            <div className="ecosystem__grid--2">
              <TabPanel className={tabcontentClass}>
                <p>Global GERS seeks to increase the number of successful ventures – by increasing the transnational capabilities of member organizations and the ventures they support. With more successful ventures, economic development and wealth creation is enhanced, potentially leading to the easing of substantial economic, social and geopolitical challenges at a local and global levels.</p>
              </TabPanel>
              <TabPanel className={tabcontentClass}>
                <p>The goals of Global GERS are to:</p>
                <ul>
                  <li>Increase the number of ventures that generate annual revenue of $1 million within three years and survive past five years</li>
                  <li>Increase the revenue of the ventures supported by members</li>
                  <li>Increase the number and quality of opportunities available to members and the ventures they support</li>
                  <li>Achieve worldwide recognition as the foremost ecosystem to grow ventures and develop their transnational capabilities</li>
                </ul>
              </TabPanel>
              <TabPanel className={tabcontentClass}>
                <p>The objectives of Global GERS are:</p>
                <ul>
                  <li>100 members by December 31, 2019</li>
                  <li>200, 400 and 600 individuals are trained in 2019, 2020 and 2021 respectively</li>
                  <li>10 global projects operational by June 30, 2019</li>
                </ul>

              </TabPanel>
              <TabPanel className={tabcontentClass}>
                <p>The value Global GERS delivers its members and their ventures includes:</p>
                <ul>
                  <li>Access to footholds in foreign countries</li>
                  <li>World class training programs that place venture growth at the center of business processes</li>
                  <li>Access to investors</li>
                  <li>Cloud-based artificial intelligence and machine learning services</li>
                  <li>Tools, best practices, and guides that ventures can use to stay secure online</li>
                  <li>Engagement in global projects that consolidate global resources and positively impact local communities</li>
                  <li>Access to shared resources and processes</li>
                  <li>Increase in local reputation and image due to greater awareness of contributions to local economic development</li>
                </ul>

              </TabPanel>
              <TabPanel className={tabcontentClass}>
                <p>Global GERS has three constituent components:</p>
                <ul>
                  <li>Portfolio of Global Projects</li>
                  <li>Governance</li>
                  <li>Online presence</li>
                </ul>
                {
                  <Markdown escapeHtml={false} source={this.state.componentsDrop} />
                }
              </TabPanel>
            </div>
          </div>
        </Tabs>
        
      </ContainerWrapper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Pages/BannerItems/Pages/Ecosystem.js